import dayjs, { Dayjs } from 'dayjs';

import { ProjectSearchDateOperator } from '../tokens';

type DateFilterLabelOptions = {
  emptyLabel: string;
  operator: ProjectSearchDateOperator;
  sentencePrefix: string;
  today?: Dayjs;
  value: string;
};

export const formatProjectSearchDateFilterLabel = ({
  emptyLabel,
  operator,
  sentencePrefix,
  today = dayjs(),
  value
}: DateFilterLabelOptions) => {
  const date = dayjs(value);
  if (!date.isValid()) return emptyLabel;

  const formattedDate = date.format(
    date.year() === today.year() ? 'MMM D' : 'MMM D, YYYY'
  );
  return `${sentencePrefix} ${operator} ${formattedDate}`;
};

export const getProjectSearchDateBounds = (value: string) => {
  const start = dayjs(value).startOf('day');
  if (!value || !start.isValid()) {
    return { dateStart: '', dateEnd: '' };
  }

  return {
    dateStart: start.toISOString(),
    dateEnd: start.add(1, 'day').startOf('day').toISOString()
  };
};
